import { viewTabHandle } from "@yjsgames/phaser-ui/tab-registry";
import { RecordTabView } from "../ui/RecordTabView.js";
import { buildBattleDialoguePresentation, buildRecordTabData } from "../ui/recordTabData.js";
import type { DomainBootstrapper } from "./BootTypes.js";

export const recordBoot: DomainBootstrapper = {
  key: "record",
  install(boot) {
    boot.tabs.registerLazy("record", {
      mount: () => {
        const { tabContent } = boot.layout;
        const view = new RecordTabView(
          boot.scene,
          tabContent.x,
          tabContent.y,
          tabContent.width,
          boot.layout.shell.tabPanelBottom,
          {
            onReplay: (dialogueId) => {
              const data = buildBattleDialoguePresentation(dialogueId);
              if (data) boot.battleDialogue.force(data);
            },
          },
        );
        return viewTabHandle(
          view,
          () => view.update(buildRecordTabData(boot.state.dialogueSeenIds())),
          () => boot.state.dialogueSeenIds().join("|"),
        );
      },
    });
  },
};
